'use client';

import { ChevronDown } from 'lucide-react';
import { Button } from '../ui/button';
import { Progress } from '../ui/progress';

type ViewMoreButtonProps = {
  disabled?: boolean;
  onViewMoreClick?: () => void;
  hasNextPage?: boolean;
  totalCount?: number;
  shownProducts?: number;
  progress?: number;
};

export function ViewMoreButton({
  disabled,
  onViewMoreClick,
  hasNextPage,
  shownProducts = 0,
  totalCount = 0,
  progress = 0,
}: ViewMoreButtonProps) {
  return (
    <>
      <div className="col-span-full mb-2 flex flex-col items-center justify-center gap-4">
        <div className="w-[13.75rem] space-y-4">
          <div className="mx-auto w-full max-w-sm text-center">
            <p className="mb-2">
              Showing {shownProducts} of {totalCount}
            </p>
            <Progress
              className="h-0.5 bg-[#aeaeae]"
              value={progress}
              showIndicatorNotch
            />
          </div>
        </div>

        {hasNextPage && (
          <div className="w-[13.75rem] space-y-4">
            <Button
              loader={disabled}
              disabled={disabled}
              variant="outline"
              className="w-full gap-1 text-base text-current decoration-current"
              onClick={() => {
                void onViewMoreClick?.();
              }}
            >
              Load More
              <ChevronDown className="size-6" strokeWidth={1.5} />
            </Button>
          </div>
        )}
      </div>
    </>
  );
}
